// /src/pages/publicTab/AboutUsTab.jsx

import React from 'react';
import PublicLexicalPage from '../../components/PublicLexicalPage';

function AboutUsTab({ onTocReady, onTocVisibleChange }) {
  return (
    <PublicLexicalPage 
      documentName="AboutUs"
      layout="plain"
      onTocReady={onTocReady}
      onTocVisibleChange={onTocVisibleChange}
    />
  );
}


export default AboutUsTab;
